import React from 'react';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {useTranslation} from "react-i18next";
import {publicTrackingSearch} from "../../api/ShipmentEndpoint";
import {RR_STATUS} from "../../constants/RRConstants";
import {useSnackbar} from "notistack";
import Grid from "@material-ui/core/Grid";
import RoutingPointsStepper from "../core/shipments/RoutingPointsStepper";
import {Divider, Paper, Typography} from "@material-ui/core";
import {IMilestoneProps, MilestonesList} from "../page-single-shipment-tracking/RoutingPointInfoList";
import {IShipment} from "../core/shipments/ShipmentList";
import Loader from "../core/Loader";
import Container from "@material-ui/core/Container";
import withWidth, {WithWidthProps} from "@material-ui/core/withWidth";
import PublicTrackingShipmentInfoCard from './PublicTrackingShipmentInfoCard';
import PublicTrackingSearch from "./PublicTrackingSearch";
import {PublicTrackingInfoCard} from "./PublicTrackingInfoComponents";
import {InfoOutlined} from "@material-ui/icons";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            flex: 1,
            justifyContent: "center"
        },
        grid: {
            "& .MuiGrid-item": {
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                flexDirection: "column"
            }
        },
        notFound: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            "& .MuiSvgIcon-root": {
                height: 100,
                width: 100
            }
        }

    }),
);

export interface PublicTrackingInterface {
    general: IShipment,
    milestones: IMilestoneProps[]
}

export const PublicTrackingSearchResultComponents: React.FC<{ search: string } & WithWidthProps> = ({
                                                                                                        search,
                                                                                                        width
                                                                                                    }) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const {enqueueSnackbar} = useSnackbar();

    const [publicTracking, setPublicTracking] = React.useState<PublicTrackingInterface[] | undefined>(undefined);


    React.useEffect(() => {
        publicTrackingSearch(search).then(({data}) => {
            const {status, response} = data;

            if (status !== RR_STATUS.OK) {
                enqueueSnackbar(t("core.server-error"), {
                    variant: "error",
                    preventDuplicate: false
                });
            } else {

                setPublicTracking(response);
            }
        })
    }, [search, enqueueSnackbar, t]);


    if (!publicTracking) {
        return <Loader/>
    }


    return (<div className={classes.root}>


            <Container>

                <Grid container
                      spacing={2}>
                    <Grid item xs={12}>
                        <PublicTrackingSearch/>
                    </Grid>
                    {publicTracking.length > 0 && <SingleShipmentHit publicTracking={publicTracking[0]} width={width}/>}
                    {publicTracking.length < 1 && <ShipmentsNotFound/>}
                </Grid>
                <Grid item xs={12}>
                    <PublicTrackingInfoCard/>
                </Grid>
            </Container>

        </div>
    );
};

export const ShipmentsNotFound = () => {
    const classes = useStyles();
    const {t} = useTranslation();

    return (<>
        <Grid item xs={12}>
            <Paper component="div" className={classes.notFound}>
                <Typography variant="h6">{t("public-tracking.info.not-found-title")}</Typography>
                <Typography variant="h6">{t("public-tracking.info.not-found-desc")}</Typography>
                <InfoOutlined/>
            </Paper>
        </Grid>
    </>)
}

export const SingleShipmentHit: React.FC<{ publicTracking: PublicTrackingInterface } & WithWidthProps> = ({
                                                                                                              publicTracking,
                                                                                                              width
                                                                                                          }) => {
    return (<>
        <Grid item xs={12}>
            <PublicTrackingShipmentInfoCard shipment={publicTracking.general}/>
        </Grid>
        <Grid item xs={12}>
            <Paper>
                <Grid container justifyContent="center"
                      alignItems="center">
                    <Grid item xs={12} sm={6}>
                        <RoutingPointsStepper routingPoints={publicTracking.general.routingPoints}
                                              isVertical={true}/>
                        <Divider/>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <MilestonesList milestones={publicTracking.milestones} width={width}/>
                    </Grid>

                </Grid>
            </Paper>
        </Grid>
    </>)
}

export default withWidth()(PublicTrackingSearchResultComponents);
